import { lazy, Suspense } from "react";
import { Spin } from "antd";
import { Route, Routes, HashRouter } from "react-router-dom";
import { RestrictedRoute } from "./RestrictedRoute";
import { PrivateRoute } from "./PrivateRoute";
import { TemplateSelector } from "../pages/templates/TemplateSelector";
import TrackPageViews from "../components/googleAnalitycs/TrackPageViews";
import ScrollToTop from "./ScrollToTop";
import SessionInactivityWatcher from "../components/session/SessionInactivityWatcher";
import Guides2 from "../pages/guides2Section/Guides2";
import Guides2Viewer from "../pages/guides2Section/Guides2Viewer";
import {
  basePath,
  calmPath,
  communityPath,
  courtesyPath,
  culturePath,
  foodPath,
  forumPublicationPath,
  homePath,
  loginPath,
  mapPath,
  passportPath,
  settingsPath,
  settingsPersonalPath,
  settingsPrivacyPath,
  settingsPrivacyBlockPath,
  settingsPrivacyPrivacyPath,
  settingsPrivacySettingsPath,
  singUpPath,
  userPassportPath,
  userPath,
  userSetupPath,
  verifyEmailPath,
  chatUserPath,
  publicationDetailPath,
  publicationGalleryPath,
  postWasNotFoundPath,
  blogSection,
  blogDetail,
  AllNoticesPath,
  businessPartner,
  idVerificationPath,
  eventsPath,
  guidesPath,
  guidesProjectPath,
  guides2Path,
  guides2ViewPath,
  guides2CheckoutPath,
  MOSTRAR_GUIAS,
  myEventsPath,
  createEventPath,
  editEventPath,
  eventDetailsPath,
  publicEventDetailsPath,
  virtualEventAccessPath,
  businessPropertiesPath,
  courtesyDetailPath,
  propertiesPath,
  propertiesEditPath,
  purchaseHistoryPath,
  promotionHistoryPath,
  communityStandardsPath,
  propertiesDashboardPath,
  editMyOwnPropertyPath,
  privacyPolicyPath,
  hashtagCategoryPath,
  communityLoginPath,
  newSideBarPath,
  startMenuPath,
  housingPropertiesPath,
  recommendationsPropertiesPath,
  propertyDetailsPath,
  housingDetailsPath,
  housingPath,
  propertyReservationPath,
  myPropertiesReservationPath,
  recoverPassPath,
  housingApplicationsPath,
  brokerProcessPath,
  brokerProcessPropertiesPath,
  brokerPropertiesDashboardPath,
  brokerPropertiesEditPath,
  brokerVerificationPath,
  brokerLandingPath,
  pruebaPath,
} from "./routes";


const GuestUser = lazy(() =>
  import("../pages/guestUser/GuestUser").then((m) => ({ default: m.GuestUser })),
);
const SingUp = lazy(() =>
  import("../pages/singup/SingUp").then((m) => ({ default: m.SingUp })),
);
const UserSetup = lazy(() =>
  import("../pages/userSetup/UserSetup").then((m) => ({ default: m.UserSetup })),
);
const LoginScreen = lazy(() =>
  import("../pages/login/LoginScreen").then((m) => ({ default: m.LoginScreen })),
);
const VerifyEmail = lazy(() =>
  import("../pages/verifyEmail/VerifyEmail").then((m) => ({ default: m.VerifyEmail })),
);
const Home = lazy(() =>
  import("../pages/home/Home").then((m) => ({ default: m.Home })),
);
const Passport = lazy(() =>
  import("../pages/passport/Passport").then((m) => ({ default: m.Passport })),
);
const Settings = lazy(() =>
  import("../pages/settings/Settings").then((m) => ({ default: m.Settings })),
);
const NotFoundPage = lazy(() =>
  import("../pages/notFoundPage/NotFoundPage").then((m) => ({ default: m.NotFoundPage })),
);
const PostWasNotFound = lazy(() =>
  import("../pages/notFoundPage/PostWasNotFound").then((m) => ({ default: m.PostWasNotFound })),
);
const SettingsPersonal = lazy(() =>
  import("../pages/settings/SettingsPersonal").then((m) => ({ default: m.SettingsPersonal })),
);
const PassportUser = lazy(() =>
  import("../pages/passport/PassportUser").then((m) => ({ default: m.PassportUser })),
);
const OwnPublications = lazy(() =>
  import("../pages/publications/OwnPublications").then((m) => ({ default: m.OwnPublications })),
);
const BuildingPage = lazy(() =>
  import("../pages/notFoundPage/BuildingPage").then((m) => ({ default: m.BuildingPage })),
);
const SettingsPrivacy = lazy(() =>
  import("../pages/settings/SettingsPrivacy").then((m) => ({ default: m.SettingsPrivacy })),
);
const SettingsPrivacySettings = lazy(() =>
  import("../pages/settings/SettingsPrivacySettings").then((m) => ({ default: m.SettingsPrivacySettings })),
);
const SettingsPrivacyPrivacy = lazy(() =>
  import("../pages/settings/SettingsPrivacyPrivacy").then((m) => ({ default: m.SettingsPrivacyPrivacy })),
);
const User = lazy(() =>
  import("../pages/user/User").then((m) => ({ default: m.User })),
);
const BlockedUI = lazy(() =>
  import("../pages/settings/settingsPrivacyMenus/BlockedUI").then((m) => ({ default: m.BlockedUI })),
);
const Chat = lazy(() =>
  import("../pages/chat/Chat").then((m) => ({ default: m.Chat })),
);
const DetailedPub = lazy(() =>
  import("../pages/publications/DetailedPub").then((m) => ({ default: m.DetailedPub })),
);
const PublicationGallery = lazy(() =>
  import("../pages/publications/PublicationGallery").then((m) => ({ default: m.PublicationGallery })),
);
const SavedPublications = lazy(() =>
  import("../pages/publications/SavedPublications").then((m) => ({ default: m.SavedPublications })),
);
const CoLiving = lazy(() => import("../pages/coLiving/CoLiving"));
const DetalleNoticiaPage = lazy(() => import("../pages/blogSection/DetalleNoticiaPage"));
const BusinessPartnerHub = lazy(() => import("../pages/businessPartner/BusinessPartnerhub"));
const IdVerificationHub = lazy(() => import("../pages/idVerification/IdVerificationHub"));
const BlogSectionPage = lazy(() => import("../pages/blogSection/BlogSectionPage"));
const SavedPlacesOfInterest = lazy(() => import("../pages/visit/SavedPlacesOfInterest"));
const CalmSection = lazy(() => import("../pages/foroSection/calmSection/CalmSection"));
const CultureSection = lazy(() => import("../pages/foroSection/cultureSection/CultureSection"));
const Comunity = lazy(() => import("../pages/foroSection/comunitySection/ComunitySection"));
const FoodSection = lazy(() => import("../pages/foroSection/foodSection/FoodSection"));
const ForoPublication = lazy(() => import("../pages/foroSection/foodSection/ForoPublication"));
const Events = lazy(() => import("../pages/eventsSection/Events"));
const EventDetails = lazy(() => import("../pages/eventsSection/eventDetails/EventDetails"));
const PublicEventCheckout = lazy(() => import("../pages/eventsSection/publicEvent/PublicEventCheckout"));
const Guide2Checkout = lazy(() => import("../pages/guides2Section/Guide2Checkout"));
const VirtualEventAccess = lazy(() => import("../pages/eventsSection/virtualAccess/VirtualEventAccess"));
const BusinessPropertiesHub = lazy(() => import("../pages/businessPartnerProperties/BusinessPropertiesHub"));
const Courtesy = lazy(() => import("../pages/courtesy/Courtesy"));
const CoWorking = lazy(() => import("../pages/coWorking/coWorking"));
const CoWorkingDetails = lazy(() => import("../pages/coWorking/coWorkingDetails/CoWorkingDetails"));
const CourtesyDetailWrapper = lazy(() => import("../components/courtesy/CourtesyDetailWrapper"));
const CoLivingDetails = lazy(() => import("../pages/coLiving/coLivingDetails/CoLivingDetails"));
const BusinessProprerties = lazy(() => import("../components/businessProperties/BusinessPropertiesProccess"));
const PropertiesPersonalData = lazy(() => import("../components/businessProperties/PropertiesPersonalData"));
const PurchaseHistory = lazy(() => import("../pages/purchaseHistory/PurchaseHistory"));
const PromotionHistory = lazy(() => import("../pages/promotionHistory/PromotionHistory"));
const Memories = lazy(() => import("../pages/memories/Memories"));
const CommunityStandards = lazy(() => import("../pages/communityStandards/CommunityStandards"));
const Dashboard = lazy(() =>
  import("../components/businessProperties/dashboard/Dashboard").then((m) => ({ default: m.Dashboard })),
);
const EditProperty = lazy(() => import("../components/businessProperties/dashboard/EditProperty"));
const PrivacyPolicy = lazy(() => import("../pages/privacyPolicy/PrivacyPolicy"));
const Hashtags = lazy(() => import("../pages/hashtags/Hashtags"));
const CommunityStandardsLogin = lazy(() => import("../pages/communityStandards/communityLogin/CommunityStandardsLogin"));
const NewSideBar = lazy(() => import("../components/NewSideBar/NewSideBar"));
const RecommendationsProperties = lazy(() => import("../components/propertyReservation/RecommendationsProperties"));
const PropertyReservationHub = lazy(() => import("../pages/propertyReservation/PropertyReservationHub"));
const MyPropertiesReservations = lazy(() => import("../components/businessProperties/dashboard/reservations/pages/MyPropertiesReservations"));
const ApplicationsHub = lazy(() => import("../pages/applications/ApplicationsHub"));
const PropertyDetails = lazy(() => import("../pages/propertyDetails/PropertyDetails"));
const HousingProperty = lazy(() => import("../components/propertyReservation/HousingProperty"));
const HousingApplicationsView = lazy(() => import("../components/applications/ui/HousingApplicationsView"));
const ApplicationsModal = lazy(() => import("../components/applications/ui/ApplicationsModal"));
const NewRebrandingLogin = lazy(() => import("../pages/newLogin/NewRebrandingLogin"));
const NewLoginForm = lazy(() =>
  import("../pages/newLogin/NewLoginForm").then((m) => ({ default: m.NewLoginForm })),
);
const NewSignUp = lazy(() =>
  import("../pages/newLogin/NewSignUp").then((m) => ({ default: m.NewSignUp })),
);
const PassRecovery = lazy(() =>
  import("../pages/passRecovery/PassRecovery").then((m) => ({ default: m.PassRecovery })),
);
const NewPassRecovery = lazy(() =>
  import("../pages/newLogin/NewPassRecovery").then((m) => ({ default: m.NewPassRecovery })),
);
const NewLoginScreen = lazy(() =>
  import("../pages/newLogin/NewLoginScreen").then((m) => ({ default: m.NewLoginScreen })),
);
const NewUserPublications = lazy(() => import("../pages/newUserPublications/NewUserPublications"));
const NomadAlert = lazy(() => import("../pages/blogSection/NomadAlert"));
const NewsDetail = lazy(() => import("../pages/blogSection/NewsDetail"));
const NewEvents = lazy(() => import("../pages/eventsSection/NewEvents"));
const Guides = lazy(() => import("../pages/guidesSection/Guides"));
const GuideProject = lazy(() => import("../pages/guidesSection/GuideProject"));
const CreateEventPage = lazy(() => import("../pages/eventsSection/CreateEventPage"));
const EditEventPage = lazy(() => import("../pages/eventsSection/EditEventPage"));
const Index = lazy(() => import("../pages/BrokerLandingPage/Index"));
const BrokerLandingPage = lazy(() => import("../pages/BrokerLandingPage/Index"));
const BrokerProcessHub = lazy(() => import("../pages/brokerVerification/BrokerProcessHub"));
const BrokerProcessPropertyHub = lazy(() => import("../pages/brokerUploadProperty/BrokerProcessPropertyHub"));
const ConfirmUpload = lazy(() => import("../components/businessProperties/steps/ConfirmUpload"));
const AllNotices = lazy(() => import("../pages/blogSection/AllNotices"));

// VIVA-1002: mientras se descarga el fragmento de la ruta. Usa el mismo Spin que
// TemplateSelector, que ya viaja en el arranque, para no engordar el bundle inicial.
const routeFallbackStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "50vh",
};

const RouteFallback = () => (
  <div style={routeFallbackStyle}>
    <Spin size="large" />
  </div>
);

export const AppRouter = () => {
  const routes = (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
      <Route element={<RestrictedRoute />}>
        <Route path={basePath} element={<NewRebrandingLogin />} />
        <Route path={loginPath} element={<NewLoginScreen />} />
        <Route path={singUpPath} element={<NewSignUp  />} />
        <Route path={recoverPassPath} element={<NewPassRecovery />} />
        <Route path={verifyEmailPath} element={<VerifyEmail />} />
        <Route path={privacyPolicyPath} element={<PrivacyPolicy />} />
        <Route
          path={communityLoginPath}
          element={<CommunityStandardsLogin />}
        />
        <Route path="/applications/:visitId" element={<ApplicationsHub />} />
        <Route
          path={housingApplicationsPath}
          element={<HousingApplicationsView />}
        />
        <Route path={brokerLandingPath} element={<Index />} />
      </Route>

      {/* ——————————————————————————————————
        Rutas accesibles SÓLO si YA estás logueado
        (equivalente a tu PrivateRoute)
    —————————————————————————————————— */}
      <Route element={<PrivateRoute />}>
        <Route path={passportPath} element={<Passport />} />
        <Route path={userPassportPath} element={<PassportUser />} />
        <Route path={userSetupPath} element={<UserSetup />} />
        <Route path={homePath} element={<Home />} />
        <Route path={settingsPath} element={<Settings />} />
        <Route path={settingsPersonalPath} element={<SettingsPersonal />} />
        <Route path={settingsPrivacyPath} element={<SettingsPrivacy />} />
        <Route path={settingsPrivacyBlockPath} element={<BlockedUI />} />
        <Route
          path={settingsPrivacySettingsPath}
          element={<SettingsPrivacySettings />}
        />
        <Route
          path={settingsPrivacyPrivacyPath}
          element={<SettingsPrivacyPrivacy />}
        />
        <Route path="/user" element={<NewUserPublications />}>
          <Route path="publications" />
          <Route path="visit" />
          <Route path="saved" />
          <Route path="memories" />
          <Route path="connections" />
          <Route path="my-events" />
          {/* Solo en ambientes con REACT_APP_MOSTRAR_GUIAS=true (Pre y Demo),
              igual que el resto del modulo de Guias. */}
          {MOSTRAR_GUIAS && <Route path="my-guides" />}
          <Route path="courtesy" />
        </Route>
        <Route path={propertiesPath} element={<BusinessProprerties />} />
        <Route path={propertiesEditPath} element={<PropertiesPersonalData />} />
        {/* <Route path={coWorkingPath} element={<CoWorking />} />
        <Route path={coWorkingDetailsPath} element={<CoWorkingDetails />} /> */}
        <Route path={businessPartner} element={<BusinessPartnerHub />} />
        <Route
          path={businessPropertiesPath}
          element={<BusinessPropertiesHub />}
        />
        <Route path={idVerificationPath} element={<IdVerificationHub />} />
        <Route path={propertiesDashboardPath} element={<Dashboard />} />
        <Route
          path={myPropertiesReservationPath}
          element={<MyPropertiesReservations />}
        />
        <Route path={editMyOwnPropertyPath} element={<EditProperty />} />
        <Route path={culturePath} element={<CultureSection />} />
        <Route path={communityPath} element={<Comunity />} />
        <Route path={foodPath} element={<FoodSection />} />
        <Route path={forumPublicationPath} element={<ForoPublication />} />
        <Route path={housingPath} element={<CoLiving />} />
        <Route path={housingDetailsPath} element={<CoLivingDetails />} />
        <Route path={calmPath} element={<CalmSection />} />
        <Route path={courtesyPath} element={<Courtesy />} />
        <Route path={courtesyDetailPath} element={<CourtesyDetailWrapper />} />
        <Route path={eventsPath} element={<NewEvents />} />
        <Route path={myEventsPath} element={<NewEvents defaultFilter="myEvents" />} />
        <Route path={createEventPath} element={<CreateEventPage />} />
        <Route path={editEventPath} element={<EditEventPage />} />
        <Route path={eventDetailsPath} element={<EventDetails />} />
        {/* Solo en ambientes con REACT_APP_MOSTRAR_GUIAS=true (Pre y Demo). */}
        {MOSTRAR_GUIAS && (
          <>
            <Route path={guidesPath} element={<Guides />} />
            <Route path={guidesProjectPath} element={<GuideProject />} />
            <Route path={guides2Path} element={<Guides2 />} />
            <Route path={guides2ViewPath} element={<Guides2Viewer />} />
          </>
        )}
        <Route path={mapPath} element={<BuildingPage />} />
        <Route path={userPath} element={<User />} />
        <Route path={chatUserPath} element={<Chat />} />
        <Route path={publicationDetailPath} element={<DetailedPub />} />
        <Route path={publicationGalleryPath} element={<PublicationGallery />} />
        <Route path={postWasNotFoundPath} element={<PostWasNotFound />} />
        {/* <Route path={blogSection} element={<BlogSectionPage />} /> */}
        <Route path={blogSection} element={<NomadAlert />} />
        <Route path={AllNoticesPath} element={<AllNotices />} />
        <Route path={purchaseHistoryPath} element={<PurchaseHistory />} />
        <Route path={promotionHistoryPath} element={<PromotionHistory />} />
        <Route path={communityStandardsPath} element={<CommunityStandards />} />
        <Route path={hashtagCategoryPath} element={<Hashtags />} />
        <Route path={newSideBarPath} element={<NewSideBar />} />
        <Route path={startMenuPath} element={<ApplicationsModal />} />
        <Route
          path={recommendationsPropertiesPath}
          element={<RecommendationsProperties />}
        />
        <Route path={housingPropertiesPath} element={<HousingProperty />} />
        <Route path={propertyDetailsPath} element={<PropertyDetails />} />
        <Route
          path={propertyReservationPath}
          element={<PropertyReservationHub />}
        />
        <Route path={brokerVerificationPath} element={<BrokerProcessHub />} />
        <Route path={brokerProcessPath} element={<BrokerProcessHub />} />
        <Route path={brokerProcessPropertiesPath} element={<BrokerProcessPropertyHub />} />
        <Route path={brokerPropertiesDashboardPath} element={<BrokerProcessHub />} />
        <Route path={brokerPropertiesEditPath} element={<BrokerProcessHub />} />
        {/* <Route path={pruebaPath} element={<ConfirmUpload />} /> */}
      </Route>

      {/* <Route path={`${blogSection}/:id`} element={<DetalleNoticiaPage />} /> */}
      <Route path={blogDetail} element={<NewsDetail />} />
      <Route path={publicEventDetailsPath} element={<PublicEventCheckout />} />
      {/* VIVA-1106: destino del correo de evento virtual. Va fuera de los dos
          guards: fuera de PrivateRoute porque CA-04 exige resolverse sin sesion,
          y fuera de RestrictedRoute porque ese manda al Feed a quien ya tiene
          token, lo que romperia CA-01. */}
      <Route path={virtualEventAccessPath} element={<VirtualEventAccess />} />
      {/* VIVA-1214: la liga que se reparte en persona durante el webinar. Con
          sesion abre el mismo catalogo de /guides2 con el cobro habilitado.

          Va fuera de los dos guards por el mismo motivo que la de arriba: fuera de
          PrivateRoute porque CA-02 exige que el visitante sin sesion vea la
          pantalla y decida entrar —PrivateRoute lo mandaria al login y perderia la
          liga—, y fuera de RestrictedRoute porque ese manda al Feed a quien ya
          tiene token, lo que romperia CA-01. La pantalla decide sola que mostrar.

          Convive con `/guides2/:guideId` sin depender del orden en que se declaren:
          React Router v6 no resuelve por orden sino por puntuacion, y un segmento
          literal gana al dinamico, asi que "contratar" nunca se lee como un
          identificador de guia. Hay una prueba que fija ese comportamiento.

          CA-03: esta ruta NO se agrega a NewNavigationsButtons ni a ningun otro
          menu. No debe existir camino hacia ella desde la navegacion. */}
      {/* Solo en ambientes con REACT_APP_MOSTRAR_GUIAS=true (Pre y Demo). */}
      {MOSTRAR_GUIAS && (
        <Route path={guides2CheckoutPath} element={<Guide2Checkout />} />
      )}

      <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );

  return (
    <HashRouter>
      <TrackPageViews />
      <ScrollToTop />
      <SessionInactivityWatcher />
      <TemplateSelector routes={routes} />
    </HashRouter>
  );
};
